type LikeProps = {
  color?: string
}

function Like({ color = '#777' }: LikeProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-label="좋아요"
    >
      <desc>좋아요</desc>
      <defs>
        <clipPath id="o4n8p4j35a">
          <path fill="none" d="M0 0h16v16H0z" data-name="사각형 3073"></path>
        </clipPath>
      </defs>
      <path fill="none" d="M0 0h24v24H0z" data-name="사각형 7544"></path>
      <g data-name="그룹 9774">
        <g
          clipPath="url(#o4n8p4j35a)"
          data-name="그룹 1312"
          transform="translate(4 4)"
        >
          <path
            fill={color}
            d="M4.724 13.777h-2.9a.8.8 0 01-.8-.8V7.446a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.8"
            data-name="패스 581"
          ></path>
          <path
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
            strokeWidth="1.2"
            d="M5.738 7.242a.447.447 0 00.221-.215 17.419 17.419 0 01.8-1.553 17.911 17.911 0 00.833-1.625 18.312 18.312 0 00-.154-2.067.606.606 0 01.321-.6 1.522 1.522 0 01.669-.159 1.638 1.638 0 011.424.892 3.69 3.69 0 01.405 2.855 18.2 18.2 0 00-.129.692h3.136a.6.6 0 01.153.019 1.507 1.507 0 011.025 2.309 1.507 1.507 0 01-.291 2.239 1.53 1.53 0 01.081.49 1.511 1.511 0 01-.818 1.341 1.605 1.605 0 01.025.277 1.511 1.511 0 01-1.509 1.509H7.037a.616.616 0 01-.164-.022c-.028-.009-1.135-.19-1.135-.19l-.333-.033m-.681.375h-2.9a.8.8 0 01-.8-.8v-5.53a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.805zm0 0h-2.9a.8.8 0 01-.8-.8v-5.53a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.805zm0 0h-2.9a.8.8 0 01-.8-.8v-5.53a.8.8 0 01.8-.8h2.9a.8.8 0 01.8.8v5.526a.8.8 0 01-.8.805z"
            data-name="패스 582"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default Like
